import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faArrowLeft, faHeart, faHandHoldingHeart, faRocket } from '@fortawesome/free-solid-svg-icons';
import './DonationsPage.css';

function DonationsPage() {
  const [copied, setCopied] = useState(false);
  const metamaskAddress = "0x4a10BA61c9Da392dEF3A6AcBD1666e1Cd902273A";

  const copyAddress = () => {
    navigator.clipboard.writeText(metamaskAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const goHomePage = () => {
    window.location.href = '/';
  };

  return (
    <div className="donations-page">
      <div className="donations-header">
        <h1>Please Support Our Clean & Creative Platform ❤️✨</h1>
      </div>

      <div className="donation-container">
        <h2>✨ Like TikTok, But Positive & Uplifting! ✨</h2>
        <p>
          No vulgarity. No profanity. Just creative, clean content. 🌟
          <br />
          Help us grow by supporting with crypto donations. 🚀
        </p>

        <div className="benefits-section">
          <h3><FontAwesomeIcon icon={faRocket} /> What Your Donation Helps Us Do:</h3>
          <ul className="benefits-list">
            <li>🛡️ Keep our platform free from negative content</li>
            <li>💻 Improve user experience with new features</li>
            <li>🌱 Support content creators who promote positivity</li>
            <li>🔍 Enhance our content moderation tools</li>
          </ul>
        </div>

        <div className="wallet-address-container">
          <h3>Black Lives & Your Support Both Matter To Us 💖 💰</h3>
          <div className="address-box">
            <span className="address">{metamaskAddress}</span>
            <button onClick={copyAddress} className="copy-button">
              <FontAwesomeIcon icon={faCopy} />
              {copied ? "Copied! ✅" : "Copy"}
            </button>
          </div>
          <p style={{ fontSize: '14px', color: '#999' }}>
            Accepted on Ethereum, Polygon, Linea, and BSC networks. 🔗
          </p>

          <div className="thank-you-message">
            <FontAwesomeIcon icon={faHandHoldingHeart} size="lg" style={{marginRight: '8px'}} />
            <span>Every donation, no matter how small, helps us create a better community for everyone! 💕</span>
          </div>

          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <p className="supporter-message">Join our community of amazing supporters! 🌈</p>
            <button onClick={goHomePage} className="glow-on-hover">
              <FontAwesomeIcon icon={faArrowLeft} style={{marginRight: '10px'}} />
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DonationsPage;